import React from 'react';
import Unit from '@leverege/unit';
import { Flex, Text } from '@leverege/ui-elements';
import UnitSelector from "../../../../attribute/formatter/UnitSelector.js";
import Formatters from '../../../../attribute/formatter/Formatters.js';
import StringComparatorValueEditor from "../../shared/StringComparatorValueEditor.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class UnitEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      changeKey: Date.now()
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate(prevProps) {
    const {
      value: pValue,
      attribute: pAttribute
    } = prevProps;
    const {
      value,
      attribute
    } = this.props;
    if (value?.type !== pValue?.type || attribute?.valueType !== pAttribute?.valueType) {
      this.init();
    }
  }
  init() {
    const {
      value,
      usage,
      context,
      attribute
    } = this.props;
    const type = attribute.valueType;
    let units = Unit.getUnitsOfType(type).map(unit => unit.symbol);
    if (type === 'temperature') {
      units = [...units, 'C', 'F', 'R'];
    }
    let baseUnit;
    if (usage === 'table') {
      const formatter = context?.formatter;
      baseUnit = formatter?.unit || value?.unit || attribute.baseUnit;
    } else {
      baseUnit = value?.unit || attribute.baseUnit;
    }
    if (!baseUnit) {
      baseUnit = units?.[0];
    }
    this.baseUnit = baseUnit;
    this.unitRegex = new RegExp(`^(-?[0-9]*\\.?[0-9]+)[ ]*(${units.join('|')})?$`);
  }
  onChange = evt => {
    const {
      attribute,
      onChange: pOnChange,
      eventData,
      value
    } = this.props;
    this.setState({
      changeKey: Date.now()
    });
    if (evt.data === 'setValue') {
      let val = {
        ...value,
        value: null
      };
      if (typeof evt.value === 'string') {
        const res = evt.value.match(this.unitRegex);
        if (res) {
          let [, value, unit = this.baseUnit] = res;
          value = parseFloat(value);
          if (unit && !Number.isNaN(value)) {
            unit = unit === 'C' ? 'degC' : unit === 'F' ? 'degF' : unit === 'R' ? 'degR' : unit;
            val = {
              type: attribute.valueType,
              value,
              unit
            };
          }
        }
      }
      pOnChange({
        data: eventData,
        value: val
      });
    } else {
      pOnChange({
        data: eventData,
        value: {
          ...value,
          type: attribute?.valueType,
          unit: evt.value
        }
      });
    }
  };
  validator = val => {
    return !val || val.match(this.unitRegex) != null;
  };
  getFormatted = value => {
    const {
      context
    } = this.props;
    const formatter = context?.formatter;
    if (formatter) {
      return Formatters.format(value, formatter) || [];
    }
    return value?.value != null ? [`${value?.value}`] : [];
  };
  render() {
    const {
      usage,
      context,
      attribute,
      value,
      suggestor,
      variant,
      ...options
    } = this.props;
    const {
      changeKey
    } = this.state;
    const [formattedValue, formattedUnit] = this.getFormatted(value);
    return /*#__PURE__*/_jsxs(Flex, {
      variant: "rowS",
      style: {
        flexGrow: 1
      },
      children: [/*#__PURE__*/_jsx(StringComparatorValueEditor, {
        variant: variant,
        suggestor: suggestor,
        onChange: this.onChange,
        value: formattedValue,
        validator: this.validator,
        eventData: "setValue"
      }), usage === 'table' && formattedUnit ? /*#__PURE__*/_jsx(Text, {
        variant: variant,
        children: formattedUnit
      }) : /*#__PURE__*/_jsx(UnitSelector, {
        variant: variant,
        ...options,
        attribute: attribute,
        style: {
          flexGrow: 1
        },
        unitType: attribute?.valueType,
        baseUnits: false,
        value: value?.unit,
        onChange: this.onChange,
        eventData: "setUnit"
      })]
    }, changeKey);
  }
}